type TranslatedLabels = {
  noLabel: string;
  yesLabel: string;
};
export const getYesNoLabel = (value: boolean, labels: TranslatedLabels) => {
  switch (value) {
    case false:
      return labels.noLabel;
    case true:
      return labels.yesLabel;
    default:
      return null;
  }
};
